(function () {
  var COLOR_TRIGGERS = ['color', 'colour', 'couleur', 'colore', 'farbe'];
  var SIZE_TRIGGERS = ['size', 'taille', 'größe', 'tamanho', 'tamaño', 'koko'];

  function isDateStale(date) {
    var parts = date.split('/');
    if (parts.length !== 3) return false;

    var year = Number(parts[2]);
    var month = Number(parts[0].indexOf('0') === 0 ? parts[0].charAt(1) : parts[0]);
    var day = Number(parts[1].indexOf('0') === 0 ? parts[1].charAt(1) : parts[1]);
    var now = new Date();
    var yearNow = now.getFullYear();
    var monthNow = now.getMonth() + 1;
    var dayNow = now.getDate();

    return (
      year > yearNow ||
      (year === yearNow && month > monthNow) ||
      (year === yearNow && month === monthNow && day > dayNow)
    );
  }

  function formatDate(dateStr) {
    var dateParts = dateStr.split('/');
    if (dateParts.length !== 3) return dateStr;
    return new Date(dateParts[2], dateParts[0] - 1, dateParts[1]).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  }

  function getPathParts() {
    var path = location.pathname.replace(/\/$/, '');
    var slug = path.split('/').pop() || '';
    var parts = slug.split('-');
    return {
      designer: parts.length ? parts[parts.length - 1] : '',
      designer2: parts.length ? parts[0] : ''
    };
  }

  function getProductKeyPrefix() {
    if (typeof product_id !== 'undefined' && product_id) {
      return String(product_id);
    }
    return getPathParts().designer;
  }

  function normalizeKeyPart(value) {
    return String(value || '')
      .trim()
      .replace(/\//g, '-')
      .replace(/\s+/g, '-');
  }

  function normalizePreorderKey(key) {
    return normalizeKeyPart(key).toLowerCase();
  }

  function buildPreorderKey(color, size) {
    var prefix = getProductKeyPrefix();
    if (!prefix || !color || !size) return '';
    return [prefix, normalizeKeyPart(color), normalizeKeyPart(size)].join('-');
  }

  function getWrapOptionName(wrap) {
    var name = wrap.getAttribute('name');
    if (name) return name;
    var handle = wrap.getAttribute('data-handle');
    return handle ? handle.replace(/-/g, ' ') : '';
  }

  function optionNameMatches(name, triggers) {
    var lower = String(name || '').toLowerCase();
    return triggers.some(function (trigger) {
      return lower.indexOf(trigger) !== -1;
    });
  }

  function getSelectedOptionValue(triggers) {
    var wraps = document.querySelectorAll('.variant-input-wrap');
    for (var i = 0; i < wraps.length; i++) {
      if (!optionNameMatches(getWrapOptionName(wraps[i]), triggers)) continue;
      var checked = wraps[i].querySelector('input[data-variant-input]:checked');
      if (checked) return checked.value;
      var selected = wraps[i].querySelector('select');
      if (selected) return selected.value;
    }

    var labels = document.querySelectorAll('.variant__label');
    for (var j = 0; j < labels.length; j++) {
      var text = labels[j].textContent || '';
      if (!optionNameMatches(text, triggers)) continue;
      var info = labels[j].querySelector('[data-variant-color-label], #currentSizeMeasurement');
      if (info && info.textContent) return info.textContent.trim();
    }

    return null;
  }

  function getSelectedValuesFromDetail(detail) {
    if (!detail || !detail.currentlySelectedValues) return null;

    var color = null;
    var size = null;
    var values = detail.currentlySelectedValues;

    var wraps = document.querySelectorAll('.variant-input-wrap');
    wraps.forEach(function (wrap) {
      var name = getWrapOptionName(wrap);
      var index = wrap.getAttribute('data-index');
      var match = values.find(function (item) {
        return item.index === index;
      });
      if (!match) return;
      if (optionNameMatches(name, COLOR_TRIGGERS)) color = match.value;
      if (optionNameMatches(name, SIZE_TRIGGERS)) size = match.value;
    });

    if (!color && values[0]) color = values[0].value;
    if (!size && values[1]) size = values[1].value;

    return { color: color, size: size };
  }

  function getSelectedVariantId() {
    var form = document.querySelector('form.product-single__form');
    if (!form) return null;
    var select = form.querySelector('select[name="id"][data-product-select]');
    if (select && select.value) return select.value;
    var input = form.querySelector('input[name="id"]');
    if (input && input.value) return input.value;
    var match = window.location.search.match(/variant=(\d+)/);
    return match ? match[1] : null;
  }

  function getQuantity() {
    var qty = document.querySelector('input[name="quantity"]');
    if (qty && qty.value) return parseInt(qty.value, 10) || 1;
    return 1;
  }

  function setAddToCartVisible(visible) {
    var atc = document.querySelector('[data-add-to-cart]');
    var popupBtn = document.querySelector('.Button--ShowPopup');
    if (atc) {
      atc.style.display = visible ? '' : 'none';
    }
    if (popupBtn) {
      popupBtn.style.display = visible ? 'none' : 'block';
      if (!visible && atc) {
        var text = atc.querySelector('[data-add-to-cart-text]');
        popupBtn.textContent = (text && text.dataset.defaultText) || popupBtn.textContent;
      }
    }
  }

  function updateView(detail) {
    try {
      if (typeof preorder_dates === 'undefined' || !Array.isArray(preorder_dates)) {
        return;
      }

      var pathParts = getPathParts();
      var selected = getSelectedValuesFromDetail(detail) || {
        color: getSelectedOptionValue(COLOR_TRIGGERS),
        size: getSelectedOptionValue(SIZE_TRIGGERS)
      };

      var message = document.querySelector('.PreOrder__message');
      var messageSpan = document.querySelector('.PreOrder__message span');
      var popupDate = document.querySelector('.PreOrder__popup-content .date');

      if (message) message.style.display = 'none';
      window.product_preorder_date = '';
      setAddToCartVisible(true);

      var keyPrefix = getProductKeyPrefix();
      if (!selected.color || !selected.size || !keyPrefix) return;

      var key = buildPreorderKey(selected.color, selected.size);
      var normalizedKey = normalizePreorderKey(key);

      preorder_dates.forEach(function (entry) {
        if (!entry || normalizePreorderKey(entry[0]) !== normalizedKey || !isDateStale(entry[1])) return;

        var formattedDate = formatDate(entry[1]);
        window.product_preorder_date = entry[1];
        window.product_preorder_str =
          pathParts.designer2 +
          '-' +
          key +
          ' - Ready to ship by ' +
          formattedDate;

        setAddToCartVisible(false);
        if (message) message.style.display = 'block';
        if (messageSpan) messageSpan.textContent = entry[1];
        if (popupDate) popupDate.textContent = formattedDate;
      });
    } catch (err) {
      console.log(err);
    } finally {
      document.dispatchEvent(
        new CustomEvent('preorder:change', {
          detail: { date: window.product_preorder_date || '' }
        })
      );
    }
  }

  function togglePopup(forceHide) {
    var popup = document.querySelector('.PreOrder__popup');
    if (!popup) return;
    if (forceHide === true) {
      popup.classList.add('PreOrder__popup_hidden');
      return;
    }
    popup.classList.toggle('PreOrder__popup_hidden');
  }

  function storePreorderProduct() {
    var message = document.querySelector('.PreOrder__message');
    if (!message || message.style.display === 'none') return;

    var products = null;
    try {
      products = JSON.parse(localStorage.getItem('po_products'));
    } catch (e) {
      products = null;
    }
    if (products == null || Array.isArray(products)) products = {};

    var variantId = getSelectedVariantId();
    if (variantId && window.product_preorder_str) {
      products[variantId] = window.product_preorder_str;
      localStorage.setItem('po_products', JSON.stringify(products));
    }
  }

  function addPreorderToCart() {
    var variantId = getSelectedVariantId();
    if (!variantId) return;

    var quantity = getQuantity();
    var cartAdd = (window.theme && theme.routes && theme.routes.cartAdd) || (window.Shopify.routes.root + 'cart/add.js');
    var item = { id: Number(variantId), quantity: quantity };

    if (window.product_preorder_date) {
      item.properties = {
        '_preorder_ship_date': window.product_preorder_date
      };
    }

    fetch(cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [item]
      })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status === 422) return;

        var form = document.querySelector('form.product-single__form');
        var atc = document.querySelector('[data-add-to-cart]');
        var product = data.items ? data.items[0] : data;

        if (form) {
          form.dispatchEvent(
            new CustomEvent('ajaxProduct:added', {
              detail: { product: product, addToCartBtn: atc },
              bubbles: true
            })
          );
        }

        document.dispatchEvent(
          new CustomEvent('ajaxProduct:added', {
            detail: { product: product, addToCartBtn: atc }
          })
        );

        var cartType = window.theme && theme.settings && theme.settings.cartType;
        var cartPage = window.theme && theme.routes && theme.routes.cartPage;

        if (cartType !== 'drawer' && cartPage) {
          window.location = cartPage;
        }
      })
      .catch(function (error) {
        console.error('Error:', error);
      });
  }

  function bindEvents() {
    var popupBtn = document.querySelector('.Button--ShowPopup');
    if (popupBtn && popupBtn.dataset.preorderBound !== 'true') {
      popupBtn.dataset.preorderBound = 'true';
      popupBtn.addEventListener('click', function () {
        var message = document.querySelector('.PreOrder__message');
        if (!message || message.style.display === 'none') return;
        togglePopup();
        storePreorderProduct();
      });
    }

    document.querySelectorAll('.PreOrder__popup-shadow, .PreOrder__popup-close').forEach(function (el) {
      if (el.dataset.preorderBound === 'true') return;
      el.dataset.preorderBound = 'true';
      el.addEventListener('click', function (evt) {
        evt.preventDefault();
        var message = document.querySelector('.PreOrder__message');
        if (!message || message.style.display === 'none') return;
        togglePopup();
      });
    });

    var buyBtn = document.querySelector('.PreOrder__buyBtn');
    if (buyBtn && buyBtn.dataset.preorderBound !== 'true') {
      buyBtn.dataset.preorderBound = 'true';
      buyBtn.addEventListener('click', function (evt) {
        evt.preventDefault();
        togglePopup(true);
        addPreorderToCart();
      });
    }

    document.addEventListener('variant:change', function (evt) {
      updateView(evt.detail);
    });

    document.querySelectorAll('[data-product-id]').forEach(function (section) {
      if (section.dataset.preorderVariantBound === 'true') return;
      section.dataset.preorderVariantBound = 'true';
      section.addEventListener('variantChange', function (evt) {
        updateView(evt.detail);
      });
    });

    document.querySelectorAll('[data-variant-input]').forEach(function (input) {
      if (input.dataset.preorderBound === 'true') return;
      input.dataset.preorderBound = 'true';
      input.addEventListener('change', function () {
        updateView(null);
      });
    });
  }

  function waitForFeedAndUpdate() {
    var attempts = 0;
    var timer = setInterval(function () {
      attempts += 1;
      if ((typeof preorder_dates !== 'undefined' && preorder_dates.length) || attempts > 40) {
        clearInterval(timer);
        updateView(null);
      }
    }, 250);
  }

  function init() {
    if (!document.querySelector('.PreOrder__message')) return;
    bindEvents();
    updateView(null);
    waitForFeedAndUpdate();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
